// src/components/Admin/Purchases/TablePurchases.js
import React, { useMemo, useState } from "react";
import {
  Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination
} from "@mui/material";
import { Edit, Delete, AttachFile } from "@mui/icons-material";

const statusColor = (s) => {
  switch (s) {
    case "paid": return "success";
    case "approved": return "info";
    case "recorded": return "warning";
    case "canceled": return "error";
    default: return "default";
  }
};

export function TablePurchases({ purchases = [], onEdit, onDelete, onAttachments }) {
  const [page, setPage] = useState(0);
  const [rpp, setRpp] = useState(20);
  const rows = useMemo(() => purchases.slice(page * rpp, page * rpp + rpp), [purchases, page, rpp]);

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Proveedor</TableCell>
              <TableCell>RUC</TableCell>
              <TableCell>Serie-Número</TableCell>
              <TableCell>Base</TableCell>
              <TableCell>IGV</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Moneda</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((p, i) => (
              <TableRow key={p.id}>
                <TableCell>{page * rpp + i + 1}</TableCell>
                <TableCell>{p.issue_date}</TableCell>
                <TableCell>{p.supplier?.name || p.supplier_name || "—"}</TableCell>
                <TableCell>{p.supplier_tax_id || "—"}</TableCell>
                <TableCell>{p.invoice_series ? `${p.invoice_series}-${p.invoice_number}` : "—"}</TableCell>
                <TableCell>{p.taxable_amount}</TableCell>
                <TableCell>{p.igv}</TableCell>
                <TableCell>{p.total}</TableCell>
                <TableCell>{p.currency}</TableCell>
                <TableCell><Chip size="small" label={p.status} color={statusColor(p.status)} /></TableCell>
                <TableCell align="right">
                  <Button onClick={() => onAttachments(p)} title="Adjuntos"><AttachFile /></Button>
                  <Button onClick={() => onEdit(p)} title="Editar"><Edit /></Button>
                  <Button onClick={() => onDelete(p)} title="Eliminar"><Delete /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div" count={purchases.length} rowsPerPage={rpp} page={page}
        rowsPerPageOptions={[10, 20, 50]}
        onPageChange={(_, p) => setPage(p)}
        onRowsPerPageChange={(e) => { setRpp(parseInt(e.target.value, 10)); setPage(0); }}
      />
    </>
  );
}
